import {Classes, Overlay} from '@blueprintjs/core';
import React from 'react';
import Form from '../../components/common/Form';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import toastr from "toastr";

class DeleteFeedModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                feed_id: this.props.selectedSourceNode ? this.props.selectedSourceNode.id ? this.props.selectedSourceNode.id : '' : '',
                admin_id: this.props.selectedSourceNode ? this.props.selectedSourceNode.user_id ? this.props.selectedSourceNode.user_id : '' : '',
            },
            selectedSourceNode: this.props.selectedSourceNode,
            workspaceName: this.props.selectedSourceNode ? this.props.selectedSourceNode.name ? this.props.selectedSourceNode.name : '' : '',
            loader: false,
            overlayIsOpen: false,
            fieldsCheckActive: false,
            errorsList: []
        };
    }

    doSubmit = async (e) => {
        await this.setState({loader: true})
        let projectId = localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        try {
            const result = await http.delete('api/user/' + getCurrentUserId() + '/project/' + projectId, {headers: {authorization: getJwt()}});
            await this.props.updateUserFromServer();
            await toastr.success('Workspace was successfully deleted');
            await this.setState({loader: false});
            await this.props.handleClose();
            await this.props.selectProject(this.props.user.sources.data[0]);
            await this.props.updateProjectData(this.props.user.sources.data[0])
        } catch {
            toastr.error('Error with deleting workspace')
            await this.setState({loader: false})
        }

    };
    componentDidUpdate = () => {

        if (this.state.selectedSourceNode !== this.props.selectedSourceNode) {
            let data = this.state.data
            let workspaceName = ''
            data.feed_id = this.props.selectedSourceNode ? this.props.selectedSourceNode.id ? this.props.selectedSourceNode.id : '' : ''
            data.user_id = this.props.selectedSourceNode ? this.props.selectedSourceNode.user_id ? this.props.selectedSourceNode.user_id : '' : ''
            workspaceName = this.props.selectedSourceNode ? this.props.selectedSourceNode.name ? this.props.selectedSourceNode.name : '' : ''
            this.setState({
                selectedSourceNode: this.props.selectedSourceNode,
                data,
                workspaceName
            })
        }
    }

    render() {
        let {visible_modal, onClickAway} = this.props;

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" id='renameFeed' style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2>Delete workspace data</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                                <span className='danger-text'>Are you sure you want to delete
                                    the <strong
                                        className='all-caps'>{this.state.workspaceName}</strong> workspace?</span>
                                <br/>
                                Please keep in mind that this deletes your workspace and all your subscribers from
                                the
                                database.
                            </div>
                            <div className='justify-content-end flex-direction-row margin-bottom-20'>

                                <button disabled={false}
                                        onClick={this.props.handleClose}
                                        name="cancel_team"
                                        id="cancel_team"
                                        type="button"
                                        className="btn-white-border margin-right-10">Cancel
                                </button>

                                {this.state.loader ?
                                    <button disabled={true}
                                            name="change_team"
                                            id="delete_team_btn"
                                            type="button"
                                            className="btn-danger">Delete <i
                                        className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button disabled={false}
                                            name="change_team"
                                            id="delete_team_btn"
                                            type="button"
                                            onClick={this.doSubmit}
                                            className="btn-danger">Delete</button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default DeleteFeedModal;